import React, { useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { BreadCrumbCss } from "./BreadcrumbCss";
import "./Breadcrumb.css";
import {
  eventFormatedDate,
  formattedTime,
  utcToZonedDate
} from "../../utils/date";
import { TimeZoneContext } from "../../contexts/TimeZoneContext";
import { formatInTimeZone } from "date-fns-tz";

interface BreadCrumbI {
  title?: string;
  competition?: string;
  date?: string;
  sport?: string;
}

const Breadcrumb = (crumb: BreadCrumbI) => {
  const timeZone = useContext(TimeZoneContext);

  return (
    <div
      className="breadcrumb-area breadcrumb-modify-padding bg-black-3"
      style={BreadCrumbCss.main}
    >
      <Container>
        <div className="in-breadcrumb">
          <Row>
            <Col>
              <div
                className="breadcrumb-style-2"
                style={BreadCrumbCss.contentContainer}
              >
                <h2 style={BreadCrumbCss.mainHeading}>
                  {crumb?.competition ?? crumb?.title}
                </h2>
                <ul
                  className="breadcrumb-list-2"
                  style={BreadCrumbCss.contentContainer}
                >
                  <li style={BreadCrumbCss.listItem}>
                    {crumb?.date &&
                      formatInTimeZone(
                        crumb?.date ?? "",
                        timeZone,
                        "MM/dd/yy hh:mm a"
                      ).toLocaleString()}
                  </li>
                  <li style={BreadCrumbCss.listItem}></li>
                </ul>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default Breadcrumb;
